const EtherealBackground = () => (
  <div
    className="fixed inset-0 w-full h-full pointer-events-none -z-10 bg-navy-950"
    aria-hidden="true"
  />
);

export default EtherealBackground;
